import React from 'react';
import { Card } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

export default function Disclaimer() {
  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto">
      <Card className="p-8 glass-card">
        <div className="flex items-center gap-3 mb-6">
          <AlertTriangle className="h-8 w-8 text-destructive" />
          <h1 className="text-4xl font-bold">Medical Disclaimer</h1>
        </div>

        <div className="space-y-6 text-muted-foreground">
          <div className="p-6 rounded-lg bg-destructive/10 border-2 border-destructive">
            <p className="text-destructive font-bold text-lg mb-2">
              IMPORTANT: FOR RESEARCH USE ONLY
            </p>
            <p className="text-destructive">
              This application and all information provided are for laboratory research and educational purposes only. 
              None of the content is intended for human consumption or use.
            </p>
          </div>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-3">Not Medical Advice</h2>
            <p>
              PeptideForge does not provide medical advice, diagnosis, or treatment. The information, including but not limited to, 
              text, graphics, images, and other material contained in this application are for informational and educational purposes only.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-3">No Doctor-Patient Relationship</h2>
            <p>
              Use of this application does not establish a doctor-patient relationship. Always seek the advice of your physician or 
              other qualified health provider with any questions you may have regarding a medical condition.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-3">Research Chemicals</h2>
            <p>
              Research peptides are chemicals intended for laboratory research use only. These products are not drugs, supplements, or 
              approved for human consumption. Users must comply with all local, state, and federal laws regarding the possession and use 
              of research chemicals.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-3">Verify COAs</h2>
            <p>
              Always verify Certificates of Analysis (COA), HPLC testing results, and endotoxin testing from your suppliers. 
              PeptideForge does not test, verify, or endorse any suppliers or products.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-3">User Responsibility</h2>
            <p>
              Users are solely responsible for:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
              <li>Verifying all calculations and dosages</li>
              <li>Ensuring compliance with local laws and regulations</li>
              <li>Proper storage and handling of research materials</li>
              <li>Understanding and accepting all risks</li>
              <li>Consulting appropriate professionals before any research</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-3">No Liability</h2>
            <p>
              PeptideForge, its developers, and affiliates shall not be held liable for any damages, injuries, or losses resulting from 
              the use or misuse of this application or any information contained within it.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-3">Age Restriction</h2>
            <p>
              This application is intended for use by individuals 18 years of age or older who are conducting legitimate laboratory research.
            </p>
          </section>

          <div className="p-4 rounded-lg bg-warning/10 border border-warning mt-8">
            <p className="text-warning font-medium">
              By using PeptideForge, you acknowledge that you have read, understood, and agree to this disclaimer.
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}